<template>
  <common-card>
    <v-toolbar color="primary" dense dark flat>
      <v-toolbar-title>
        <span class="font-montserrat font-weight-bold">Reporte de Redenciones Alianzas</span>
      </v-toolbar-title>
    </v-toolbar>

    <v-card-text>
      <v-row>
        <v-col md="3">
          <v-select
            label="Seleccionar una Alianza"
            :items="alianzas"
            item-text="nombre"
            item-value="id"
            v-model="alianza"
            outlined
            class="mt-5"
          />

          <v-select
            label="Seleccionar tipo"
            :items="tipos"
            v-model="tipoSeleccionado"
            outlined
            class="mt-4"
          />

          <v-radio-group v-model="modo" row>
            <v-radio label="Rango de fechas" value="rango" />
            <v-radio label="Últimos 3 meses" value="general" />
          </v-radio-group>

          <v-date-picker
            v-if="modo === 'rango'"
            v-model="dates"
            range
            :allowed-dates="allowedDate"
            locale="es"
          />

          <v-btn
            block
            color="primary"
            dark
            :loading="loading"
            :disabled="!puedeEjecutar"
            class="mt-4"
            @click="consultar"
          >
            Ejecutar
          </v-btn>

          <v-btn
            block
            class="mt-3"
            color="success"
            :disabled="total === 0"
            @click="descargarCSV"
          >
            Descargar
          </v-btn>
        </v-col>

        <v-col md="9">
          <v-data-table
            :headers="columns"
            :items="redenciones"
            :options.sync="options"
            :server-items-length="total"
            :loading="loading"
            :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
            disable-sort
            class="elevation-1"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </common-card>
</template>

<script>
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import moment from "moment";
import { getAlianzas } from "@/services/alianzas/alianzas.service.js";
import {
  getReporteRedencionesAlianzas,
  getReporteRedencionesCSV,
} from "@/services/reportes/reportes.service.js";

export default {
  name: "ReporteRedencionesAlianzas",
  components: { CommonCard },
  data() {
    return {
      alianzas: [],
      alianza: null,

      tipos: ["Asistencia", "Beneficio"],
      tipoSeleccionado: null,

      modo: "rango",
      dates: [],

      redenciones: [],
      options: { page: 1, itemsPerPage: 10 },
      total: 0,
      loading: false,
      filtrosAplicados: null,

      columns: [
        { text: "ID Solicitud", value: "idSolicitud" },
        { text: "Fecha redencion", value: "fechaRedencion" },
        { text: "Tipo", value: "tipo" },
        { text: "Categoria", value: "categoria" },
        { text: "Nombre Redención", value: "nombreRedencion" },
      ],
    };
  },
  computed: {
    limiteMin() {
      return moment("2025-12-01").startOf("day");
    },
    hoy() {
      return moment().endOf("day");
    },
    puedeEjecutar() {
      const base = this.alianza && this.tipoSeleccionado;
      if (!base) return false;
      if (this.modo === "general") return true;
      return (
        this.modo === "rango" &&
        this.dates.length === 2 &&
        this.allowedDate(this.dates[0]) &&
        this.allowedDate(this.dates[1])
      );
    },
  },
  watch: {
    options: {
      handler() {
        if (this.filtrosAplicados) this.cargarPagina();
      },
      deep: true,
    },
  },
  methods: {
    allowedDate(fecha) {
      const f = moment(fecha);
      return f.isSameOrAfter(this.limiteMin) && f.isSameOrBefore(this.hoy);
    },
    armarFiltros() {
      const filtros = {
        alianza: Number(this.alianza),
        tipo: this.tipoSeleccionado,
        order: "desc",
      };
      if (this.modo === "rango" && this.dates.length === 2) {
        filtros.fechas = [
          moment(this.dates[0]).startOf("day").utc().format("YYYY-MM-DD HH:mm:ss"),
          moment(this.dates[1]).endOf("day").utc().format("YYYY-MM-DD HH:mm:ss"),
        ];
      }
      return filtros;
    },

    async cargarPagina() {
      const { page, itemsPerPage } = this.options;
      this.loading = true;
      try {
        const res = await getReporteRedencionesAlianzas({
          ...this.filtrosAplicados,
          limit: itemsPerPage,
          page: page - 1,
        });
        this.redenciones = (res.data || []).map((r) => ({
          ...r,
          fechaRedencion: r.fechaRedencion
            ? moment.utc(r.fechaRedencion).local().format("DD/MM/YYYY HH:mm")
            : "",
        }));
        this.total = res.count ?? 0;
      } catch (e) {
        this.redenciones = [];
        this.total = 0;
        this.$toast.error("Error al consultar el reporte");
      } finally {
        this.loading = false;
      }
    },

    consultar() {
      this.filtrosAplicados = this.armarFiltros();
      if (this.options.page !== 1) {
        this.options = { ...this.options, page: 1 };
        return;
      }
      this.cargarPagina();
    },

    async descargarCSV() {
      const body = {
        alianzaId: Number(this.alianza),
        tipo: this.tipoSeleccionado,
      };

      if (this.modo === "rango" && this.dates.length === 2) {
        const inicio = moment(this.dates[0]).startOf("day");
        const fin = moment(this.dates[1]).endOf("day");
        body.fechas = [
          inicio.utc().format("YYYY-MM-DD HH:mm:ss"),
          fin.utc().format("YYYY-MM-DD HH:mm:ss"),
        ];
      }

      await getReporteRedencionesCSV(body);
    },
  },
  async mounted() {
    try {
      this.alianzas = (await getAlianzas()) || [];
    } catch (e) {
      this.alianzas = [];
      console.error("Error al obtener alianzas:", e);
      this.$toast.error("No se pudieron cargar las alianzas");
    }
  },
};
</script>
